<template>
  <header
    class="fixed inset-x-0 top-0 z-20 flex flex-wrap items-center justify-between gap-x-3 gap-y-2 border-b border-stone-200/90 bg-white/85 px-4 pb-2 pt-[calc(0.5rem+env(safe-area-inset-top))] backdrop-blur-xl min-[480px]:px-6 dark:border-white/[0.08] dark:bg-[rgba(12,10,18,0.88)]"
  >
    <!-- Optional named slot `toolbar`: form actions (e.g. Save) — parent uses <template #toolbar>...</template> -->
    <div class="flex min-w-0 flex-1 flex-wrap items-center gap-2">
      <slot name="toolbar" />
    </div>
    <div class="flex shrink-0 flex-wrap items-center justify-end gap-2">
      <ThemeToggle />
      <LangSwitch />
      <button
        v-if="signedIn"
        type="button"
        class="shrink-0 cursor-pointer rounded-xl border border-stone-200/95 bg-white/90 px-3.5 py-2 text-sm font-medium text-stone-800 hover:border-amber-500/50 hover:bg-amber-50/80 hover:text-amber-950 dark:border-white/10 dark:bg-white/[0.06] dark:text-[#f4ebe0] dark:hover:border-[rgba(242,216,150,0.45)] dark:hover:bg-white/[0.1] dark:hover:text-[#f2d896]"
        @click="signOut"
      >
        {{ $t('dash.logout') }}
      </button>
    </div>
  </header>
</template>

<script setup lang="ts">
defineProps<{
  signedIn?: boolean
}>()

async function signOut() {
  await apiJson('/api/auth/logout', { method: 'POST' })
  await navigateTo('/login', { replace: true })
}
</script>
